export default {
  getMainData: '/courier-sqp-api/h5/v3/serviceScore/rank',
  getTimesData: '/v3/serveScore/new/violationsTimesV3',
  signIn: '/v3/serveScore/new/arrive',
  getStarOverview: '/courier-sqp-api/h5/v3/serviceStar/overview'
}
